module.exports = {"text":"module.exports = __webpack_public_path__ + \"static/media/drop_previous.23afb26a.svg\";"};
module.exports['default'] = module.exports;
